export default "__VITE_ASSET__DK98NTao__"